/**
 * 数科-臻有钱提现页-活动弹窗 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱提现页-活动弹窗
 * uuid:82459ae539c74b1194f8aa3572ad6a09
 */
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

import { Popup } from 'vant';

import { namespace } from 'vuex-class';
import { PeriodOption } from '@/views_v2/apply-product/types';
import platform from '@/shared/utils/platform';
import AdvCommonContainer from '../adv-common-container';
import style from './index.module.scss';

const ApplyProductStore = namespace('applyProduct');

const AdvMasterUuid = '82459ae539c74b1194f8aa3572ad6a09';

interface ApplyingCofigType {
  defaultImg: string;
  data: ApplyWordType;
  styleUrl: string;
}

interface ApplyWordType {
  impId: string;
  marketingDiscountPriceTag: string;
}

 @Component
export default class AdvApplyPopup extends Vue {
  /** 产品id */
  @Prop(String) readonly commodityId!: string;

  /** 外采渠道id */
  @Prop(String) readonly sourceId!: string;

  @ApplyProductStore.State amount!: string;

  @ApplyProductStore.State period!: PeriodOption | undefined;

  @ApplyProductStore.State needLoadingAdvPopup !:boolean;

  private startRender = false;

  @Watch('needLoadingAdvPopup')
  private loadingAdvPopup() {
    // 试算数据结束后并计算完期限数据后该值会更新触发
    if (this.needLoadingAdvPopup) {
      this.startRender = true;
    }
  }

  private showRightPop :null | boolean = null;

  private configData: ApplyWordType | null = null;

  /** 广告位埋点数据 */
  private trackerData: Dictionary | undefined;

  /** 动态传参 */
  private get extendInfos() {
    return {
      productId: this.commodityId,
      orderAmount: this.amount,
      sourceId: this.sourceId,
      period: this.period && this.period.period,
      ...platform.currentPlatformType,
    };
  }

  /** 埋点参数 */
  private get tqParams() {
    return {
      productId: this.commodityId || '',
      taskId: (this.trackerData && this.trackerData.task_id) || '',
      childrenTaskId: (this.trackerData && this.trackerData.child_task_id) || '',
      taskName: (this.trackerData && this.trackerData.task_name) || '',
      childrenTaskName: (this.trackerData && this.trackerData.child_task_name) || '',
    };
  }

  /** 折扣文案 */
  private get marketingDiscountPriceTag() {
    return this.configData && this.configData.marketingDiscountPriceTag;
  }

  private close() {
    this.showRightPop = false;
    this.$ubtPageButtonNew('finance_loan_apply_popup_close', this.tqParams);
  }

  private renderRightPop() {
    return (
      <Popup
        v-model={this.showRightPop}
        close-on-click-overlay={false}
        style={ { backgroundColor: 'transparent' } }
      >
      <div class={style.applyPop}>
        <div class={style.rightContent}>
          <p class={style.title}>恭喜获得限时折扣</p>
          <p class={style.text}>急速审核特权<span>{this.marketingDiscountPriceTag}购</span></p>

          <div class={style.rightCard}>
            <div class={style.preferentialText}>{this.marketingDiscountPriceTag}购</div>
            <span>名额有限</span>
          </div>
          <button onClick={this.close.bind(this)}> 领取特权</button>
        </div>
      </div>
      <div class={style.close} onClick={this.close.bind(this)}></div>
    </Popup>);
  }

  private shouldSelfRender(data: {creative: Dictionary[]}) {
    if (data && data.creative && data.creative.length) {
      const { segment } = data.creative[0] || [];
      if (segment) {
        this.configData = (segment as ApplyingCofigType).data;
        if (this.marketingDiscountPriceTag) {
          return true;
        }
      }
    }
    return false;
  }

  private dataHanlder(data: {creative: Dictionary[]}) {
    // 如果没有数据，则什么都不展示
    if (!data || !data.creative || !data.creative.length) return;

    if (data && data.creative && data.creative.length) {
      const { segment, tracker } = data.creative[0] || [];
      if (segment) {
        this.configData = (segment as ApplyingCofigType).data;
        if (this.marketingDiscountPriceTag) {
          this.showRightPop = true;
          setTimeout(() => {
            this.showRightPop = false;
          }, 4000);
        }
      }
      if (tracker) {
        this.trackerData = tracker as Dictionary;
      }
      this.$ubtModuleExposeNew('finance_loan_apply_popup', this.tqParams);
    }
  }

  private render() {
    return (
      this.startRender ? (
      <div>
        {this.renderRightPop()}
        <AdvCommonContainer
           advMasterId={AdvMasterUuid}
           onDataLoad={this.dataHanlder.bind(this)}
           advExtendInfo={this.extendInfos}
           shouldSelfRender={this.shouldSelfRender.bind(this)}
         />
      </div>
      ) : null
    );
  }
}
